import { TUser } from "~/types";
import { baseService, instanceWithoutInterceptors } from "../base";
import { AuthCredentials, Tokens } from "./auth.types";

export const authServices = {
  getMe: async () => {
    const { data } = await baseService.get<TUser>("/users/me");
    return data;
  },
  login: async (credentials: AuthCredentials) => {
    const { data } = await baseService.post<Tokens>("/auth/login", credentials);
    return data;
  },
  refreshToken: async (refreshToken: string) => {
    const { data } = await instanceWithoutInterceptors.get<Tokens>(
      "/auth/refresh-token",
      {
        headers: {
          Authorization: `Bearer ${refreshToken}`,
        },
      }
    );
    return data;
  },
  requestPasswordReset: async (email: string) => {
    await baseService.post("/auth/request-password-reset", { email });
  },
  resetPassword: async (token: string, password: string) => {
    const { data } = await baseService.post("/auth/reset-password", {
      token,
      password,
    });
    return data;
  },
};
